import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { LandingPage } from './pages/LandingPage';
export function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <LandingPage data-id="element-1" />
    </>;
}